module.exports = __webpack_public_path__ + "img/produkt-cibule.ffcba5ce.jpg";